// extracted by mini-css-extract-plugin
export var container = "_47-0";
export var icon = "_47-1";
export var text = "_47-2";